import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import DashboardLayout from '@/components/layout/DashboardLayout';

export default function RevenueOverview() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['admin-revenue-overview'],
    queryFn: async () => {
      // Basic revenue signals from local tables; Stripe MCP integration can enhance later
      const { count: activeSubs } = await supabase
        .from('posit_subscriptions')
        .select('*', { count: 'exact', head: true })
        .eq('status', 'active');

      // Approximate MRR if price mapping exists in app constants
      // For now return active subs only
      return { activeSubs: activeSubs ?? 0 };
    }
  });

  return (
    <DashboardLayout title="Revenue" description="High-level revenue signals. Detailed Stripe metrics can be added." maxWidth="4xl">
      {error && <div className="text-red-600 text-sm">{String((error as any)?.message || error)}</div>}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="p-4 border rounded-lg">
          <div className="text-sm text-muted-foreground">Active Subscriptions</div>
          <div className="text-2xl font-semibold">{isLoading ? '…' : data?.activeSubs}</div>
        </div>
      </div>
    </DashboardLayout>
  );
}


